export enum BuildingActionTypes{
    API_RESPONSE_SUCCESS = '@@building/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@building/API_RESPONSE_ERROR',
    ADD_BUILDING = '@@building/ADD_BUILDING',
    UPDATE_BUILDING = '@@building/UPDATE_BUILDING',
    DELETE_BUILDING = '@@building/DELETE_BUILDING',
    GET_AllBUILDINGS = '@@building/GET_AllBUILDINGS',
}
